export const REGEX_NAME = /^[a-zA-Z ]+$/
export const REGEX_SIREN = /^[0-9]{9}$/
export const REGEX_SIRET = /^[0-9]{14}$/
export const REGEX_PHONE = /^[0-9]+$/

export const SERVICE_RATE_ACRE = 10.6
export const SELLING_RATE_ACRE = 6.2
export const OTHER_RATE_ACRE = 11.6

export const SERVICE_RATE = 21.2
export const SELLING_RATE = 12.3
export const OTHER_RATE = 21.1
export const TRAINING_RATE = 0.2
